<template>
    <v-tabs-items v-model="tab" elevation="0">
        <v-tab-item v-for="item in items" :key="item.name">
            <component :is="item.name"></component>
            <dms-users-form-actions v-if="item.hasActions" :my-profile="true"></dms-users-form-actions>
        </v-tab-item>
    </v-tabs-items>
</template>

<script>
export default {
    data() {
        return {
            items: [
                { name: 'dms-user-profile', hasActions: false },
                { name: 'dms-user-password', hasActions: true },
            ],
        };
    },
    computed: {
        tab: {
            get() {
                return this.$store.state.dms_roles.tab;
            },
            set(value) {
                this.$store.dispatch('dms_roles/changeTab', value);
            },
        },
    },
};
</script>

<style></style>
